import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Trans } from "react-i18next";

const ExtraViewer = ({ extraData }) => {
  const [progress, setProgress] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Funciones para pausar/reanudar autoplay
  const handlePause = () => {
    const swiperInstance = document.querySelector(".extra-viewer .swiper").swiper;
    swiperInstance.autoplay.stop();
    setIsPaused(true);
  };

  const handleResume = () => {
    const swiperInstance = document.querySelector(".extra-viewer .swiper").swiper;
    swiperInstance.autoplay.start();
    setIsPaused(false);
  };

  // Componente de efectos de fondo estilo cómic para extras
  const ExtraBackgroundEffects = ({ slideIndex }) => {
    // Diferentes patrones basados en el índice de la slide
    const patternType = slideIndex % 5;
    
    const renderPattern = () => {
      switch(patternType) {
        case 0: // Estrellas radiantes
          return [...Array(16)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-yellow-400 opacity-15"
              style={{
                width: "1px",
                height: "100%",
                left: `${6.25 * i}%`,
                transform: `rotate(${22.5 * i}deg)`,
                transformOrigin: "center bottom",
              }}
            />
          ));
        case 1: // Rayos convergentes
          return [...Array(14)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-cyan-400 opacity-15"
              style={{
                width: "2px",
                height: "100%",
                left: `${7.14 * i}%`,
                transform: `rotate(${-45 + (i * 6.5)}deg)`,
                transformOrigin: "center bottom",
              }}
            />
          ));
        case 2: // Rayos en X
          return [...Array(6)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-pink-400 opacity-15"
              style={{
                width: "2px",
                height: "120%",
                left: `${16.66 * i}%`,
                transform: `rotate(${i % 2 === 0 ? 30 : -30}deg)`,
                transformOrigin: "center center",
              }}
            />
          ));
        case 3: // Espirales
          return [...Array(10)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-indigo-400 opacity-15"
              style={{
                width: "2px",
                height: "100%",
                left: `${10 * i}%`,
                transform: `rotate(${36 * i}deg)`,
                transformOrigin: "center bottom",
              }}
            />
          ));
        case 4: // Líneas cruzadas
          return [...Array(8)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-orange-400 opacity-15"
              style={{
                width: "2px",
                height: "120%",
                left: `${12.5 * i}%`,
                transform: `rotate(${i % 2 === 0 ? 60 : -60}deg)`,
                transformOrigin: "center center",
              }}
            />
          ));
        default:
          return null;
      }
    };

    return (
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {renderPattern()}
      </div>
    );
  };

  return (
    <div className="relative w-full h-full bg-black bg-opacity-90 extra-viewer">
      {isPaused && (
        <div
          className="absolute top-8 right-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-yellow-500 px-4 py-2 rounded-lg z-50 transition-opacity duration-500"
          style={{ pointerEvents: "none" }}
        >
          <Trans i18nKey="pause" />
        </div>
      )}

      <div
        className="absolute inset-0 flex justify-center items-center z-40"
        style={{ pointerEvents: "none" }}
      >
        <div
          className="w-3/4 h-3/4 cursor-pointer"
          style={{ pointerEvents: "auto" }}
          onMouseDown={handlePause}
          onMouseUp={handleResume}
          onTouchStart={handlePause}
          onTouchEnd={handleResume}
        ></div>
      </div>

      <Swiper
        modules={[Autoplay, Navigation]}
        slidesPerView={1}
        navigation
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        onSlideChange={(swiper) => {
          const currentProgress = (swiper.activeIndex + 1) / swiper.slides.length;
          setProgress(currentProgress);
        }}
        speed={1000}
      >
        {extraData.map((extra, index) => (
          <SwiperSlide key={index}>
            <div
              className="relative flex flex-col items-center justify-center text-center px-4"
              style={{ minHeight: "calc(var(--vh, 1vh) * 100 - 50px)" }}
            >
              {/* Efectos de fondo estilo cómic para extras */}
              <ExtraBackgroundEffects slideIndex={index} />
              
              {/* Imagen del extra */}
              <img
                src={extra.image}
                alt={`Extra ${index + 1}`}
                className="relative z-10 w-auto max-h-full object-contain mb-4"
                style={{ maxHeight: "calc(var(--vh, 1vh) * 80)" }}
              />
              
              {/* Subtítulo si existe */}
              {extra.subtitle && (
                <p className="relative z-10 text-white text-lg font-semibold bg-black bg-opacity-50 px-4 py-2 rounded-lg">
                  {extra.subtitle}
                </p>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="absolute bottom-0 left-0 w-full h-2 bg-gray-800 z-50">
        <div className="h-full bg-yellow-500" style={{ width: `${progress * 100}%` }}></div>
      </div>
    </div>
  );
};

export default ExtraViewer;
